module.exports = __webpack_public_path__ + "static/12-gladiator-sparta-head-dac6f2e19acde106a1cd062a1817c38b.png";